/* MooseBorn — Arctic Ops interactions (no dependencies). */
(() => {
  'use strict';
  const d = document;
  const w = window;
  const $ = (s, r = d) => r.querySelector(s);
  const $$ = (s, r = d) => Array.from(r.querySelectorAll(s));
  const reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasIO = 'IntersectionObserver' in w;
  const once = (el, key) => { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; };
  const money = (cents) => {
    const cur = (w.Shopify && w.Shopify.currency && w.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(d.documentElement.lang || 'en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };
  const moneyShort = (c) => money(c).replace(/\.00(?!\d)/, '');

  /* ---------- Reveal ---------- */
  function initReveal(root = d) {
    const els = $$('.mb-reveal:not(.is-in)', root);
    if (!hasIO || reduce) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }), { rootMargin: '80px 0px 80px 0px', threshold: 0 });
    els.forEach((e) => io.observe(e));
    w.setTimeout(() => els.forEach((e) => { if (e.getBoundingClientRect().top < w.innerHeight) e.classList.add('is-in'); }), 1200);
  }

  /* ---------- Header + mobile menu ---------- */
  function initHeader() {
    const h = $('[data-mb-header]');
    if (!h || !once(h, 'mbInit')) return;
    const onScroll = () => h.classList.toggle('is-scrolled', w.scrollY > 8);
    onScroll();
    w.addEventListener('scroll', onScroll, { passive: true });
    const menu = $('[data-mb-menu]');
    const btn = $('[data-mb-menu-open]');
    if (!menu || !btn) return;
    const open = () => {
      menu.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => menu.classList.add('is-open')));
      btn.setAttribute('aria-expanded', 'true');
      d.documentElement.classList.add('mb-lock');
      const f = $('[data-mb-menu-close]:not(.mb-menu__backdrop)', menu);
      if (f) f.focus();
    };
    const close = () => {
      menu.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      d.documentElement.classList.remove('mb-lock');
      setTimeout(() => { menu.hidden = true; }, 400);
      btn.focus();
    };
    btn.addEventListener('click', open);
    $$('[data-mb-menu-close]', menu).forEach((b) => b.addEventListener('click', close));
    $$('a', menu).forEach((a) => a.addEventListener('click', () => { if ((a.getAttribute('href') || '').startsWith('#')) close(); }));
    menu.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  /* ---------- Announcement rotation (mobile) ---------- */
  function initAnnounce() {
    $$('[data-mb-announce]').forEach((t) => {
      const items = $$('.mb-announce__item', t);
      if (items.length < 2 || reduce || !once(t, 'mbInit')) return;
      let i = 0;
      items[0].classList.add('is-active');
      setInterval(() => { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, 3600);
    });
  }

  /* ---------- Ticker: duplicate content so the marquee loops ---------- */
  function initTicker(root = d) {
    $$('[data-mb-ticker]', root).forEach((t) => {
      if (!once(t, 'mbInit')) return;
      const track = $('.mb-ticker__track', t);
      if (!track) return;
      track.innerHTML += track.innerHTML;
      // Speed scales with content so short lists don't whip past
      const secs = Math.max(18, Math.round(track.scrollWidth / 90));
      track.style.animationDuration = secs + 's';
    });
  }

  /* ---------- Rails: dots + optional auto-advance ---------- */
  function initRails(root = d) {
    $$('[data-mb-rail]', root).forEach((rail) => {
      if (!once(rail, 'mbDots')) return;
      const items = Array.from(rail.children);
      if (items.length < 2) return;
      const dots = d.createElement('div');
      dots.className = 'mb-dots';
      let current = 0;
      let touched = false;
      const goTo = (i) => rail.scrollTo({ left: items[i].offsetLeft - rail.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      items.forEach((_, i) => {
        const b = d.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', ((w.mbStrings && w.mbStrings.goToItem) || 'Go to item [n]').replace('[n]', i + 1));
        if (i === 0) b.classList.add('is-active');
        b.addEventListener('click', () => { touched = true; goTo(i); });
        dots.appendChild(b);
      });
      rail.after(dots);
      const mark = (i) => { current = i; Array.from(dots.children).forEach((b, k) => b.classList.toggle('is-active', k === i)); };
      if (hasIO) {
        const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) mark(items.indexOf(e.target)); }), { root: rail, threshold: 0.6 });
        items.forEach((it) => io.observe(it));
      }
      const every = parseInt(rail.dataset.autoslide, 10);
      if (every && !reduce) {
        let onScreen = false;
        ['pointerdown', 'wheel', 'touchstart'].forEach((ev) => rail.addEventListener(ev, () => { touched = true; }, { passive: true }));
        if (hasIO) new IntersectionObserver((es) => { onScreen = es[0].isIntersecting; }, { threshold: 0.3 }).observe(rail);
        setInterval(() => {
          if (touched || !onScreen || d.hidden) return;
          if (rail.scrollWidth <= rail.clientWidth + 40) return;
          goTo((current + 1) % items.length);
        }, every);
      }
    });
  }

  /* ---------- Tabs (generic, also drives the week-by-week panel) ---------- */
  function initTabs(root = d) {
    $$('[data-mb-tabs]', root).forEach((t) => {
      if (!once(t, 'mbInit')) return;
      const list = $('[role="tablist"]', t);
      const tabs = $$('[role="tab"]', t);
      const select = (i, focus) => {
        tabs.forEach((b, k) => {
          const on = k === i;
          b.setAttribute('aria-selected', String(on));
          b.tabIndex = on ? 0 : -1;
          const p = d.getElementById(b.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        if (focus) tabs[i].focus({ preventScroll: true });
        if (list && list.scrollWidth > list.clientWidth + 2) list.scrollTo({ left: tabs[i].offsetLeft - (list.clientWidth - tabs[i].offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
        initReveal(t);
      };
      tabs.forEach((b, i) => {
        b.addEventListener('click', () => select(i, false));
        b.addEventListener('keydown', (e) => {
          let n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (n !== null) { e.preventDefault(); select(n, true); }
        });
      });
      // Deep link: #reviews → open the reviews tab
      const target = tabs.findIndex((b) => b.dataset.hash && w.location.hash === '#' + b.dataset.hash);
      if (target >= 0) select(target, false);
      $$('a[href^="#"]').forEach((a) => a.addEventListener('click', () => {
        const i = tabs.findIndex((b) => b.dataset.hash && a.getAttribute('href') === '#' + b.dataset.hash);
        if (i >= 0) select(i, false);
      }));
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    const track = $('[data-mb-track]', root);
    if (!track || !once(root, 'mbInit')) return;
    const slides = $$('.mb-gallery__slide', track);
    const dots = $$('[data-mb-dot]', root);
    const thumbs = $$('[data-mb-thumb]', root);
    const count = $('[data-mb-index]', root);
    const prev = $('[data-mb-prev]', root);
    const next = $('[data-mb-next]', root);
    let idx = 0;
    const go = (i) => { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' }); };
    const mark = (i) => {
      idx = i;
      dots.forEach((dt, k) => dt.classList.toggle('is-active', k === i));
      thumbs.forEach((th, k) => { th.classList.toggle('is-active', k === i); if (k === i && th.scrollIntoView) th.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); });
      if (count) count.textContent = String(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      // Play the visible video, pause the rest
      slides.forEach((s, k) => { const v = $('video', s); if (!v) return; if (k === i) { const p = v.play(); if (p && p.catch) p.catch(() => {}); } else v.pause(); });
    };
    let t;
    track.addEventListener('scroll', () => { clearTimeout(t); t = setTimeout(() => mark(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))), 60); }, { passive: true });
    dots.forEach((dt) => dt.addEventListener('click', () => go(+dt.dataset.mbDot)));
    thumbs.forEach((th) => th.addEventListener('click', () => go(+th.dataset.mbThumb)));
    if (prev) prev.addEventListener('click', () => go(idx - 1));
    if (next) next.addEventListener('click', () => go(idx + 1));
    track.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); } });
    mark(0);
  }

  /* ---------- Product form ---------- */
  function initPdp(root) {
    const form = $('[data-mb-form]', root);
    const jsonEl = $('[data-mb-product]', root);
    if (!form || !jsonEl || !once(root, 'mbInit')) return;
    const product = JSON.parse(jsonEl.textContent);
    const variant = product.variants.find((v) => String(v.id) === String($('[name="id"]', form).value)) || product.variants[0];
    const atc = $('[data-mb-atc]', form);
    const atcText = $('[data-mb-atc-text]', form);
    const err = $('[data-mb-error]', form);
    const planInputs = $$('input[name="selling_plan"]', form);
    // Radios when the shopper can choose; a single hidden input when the product is subscription-only
    const selectedPlan = () => planInputs.find((i) => i.type === 'hidden' || i.checked);
    const priceNow = $('[data-mb-price]', root);
    const priceWas = $('[data-mb-was]', root);
    const priceTag = $('[data-mb-save]', root);
    const sticky = $('[data-mb-sticky]', root);
    // Locale-aware strings rendered by Liquid onto the form (locales/*.json → mb.product.*)
    const i18n = form.dataset;
    const atcLabel = atcText ? atcText.textContent : (i18n.i18nAtc || 'Add to cart');
    const offText = (pct, forever) => ((forever ? i18n.i18nOffForever : i18n.i18nOff) || (forever ? '[pct]% off for life' : '[pct]% off')).replace('[pct]', pct);

    // Each plan radio carries data-price / data-compare (cents) rendered by Liquid
    const render = () => {
      const sel = selectedPlan();
      const price = sel && sel.dataset.price ? +sel.dataset.price : variant.price;
      const cmp = sel && sel.dataset.compare ? +sel.dataset.compare : (variant.compare_at_price || 0);
      // Prefer the Liquid-formatted strings so the big price matches the plan rows in every market currency
      const priceText = sel && sel.dataset.priceText ? sel.dataset.priceText : money(price);
      const cmpText = sel && sel.dataset.compareText ? sel.dataset.compareText : money(cmp);
      if (priceNow) priceNow.textContent = priceText;
      const showWas = cmp && cmp > price;
      if (priceWas) { priceWas.hidden = !showWas; if (showWas) priceWas.textContent = cmpText; }
      if (priceTag) { priceTag.hidden = !showWas; if (showWas) { const pct = Math.round((1 - price / cmp) * 100); const b = $('b', priceTag); if (b) b.textContent = offText(pct, sel && sel.dataset.forever === 'true'); } }
      if (sticky) { const sp = $('[data-mb-sticky-price]', sticky); if (sp) sp.textContent = priceText; const sv = $('[data-mb-sticky-variant]', sticky); if (sv && sel) sv.textContent = sel.dataset.label || ''; }
      if (atcText) atcText.textContent = sel && sel.dataset.cta ? sel.dataset.cta : atcLabel;
    };
    planInputs.forEach((i) => i.addEventListener('change', render));
    render();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (atc.disabled || atc.classList.contains('is-loading')) return;
      err.hidden = true;
      atc.classList.add('is-loading');
      const sel = selectedPlan();
      const item = { id: Number($('[name="id"]', form).value), quantity: 1 };
      if (sel && sel.value) item.selling_plan = Number(sel.value);
      const drawer = d.querySelector('cart-drawer');
      const body = { items: [item] };
      if (drawer && drawer.getSectionsToRender) {
        body.sections = drawer.getSectionsToRender().map((s) => s.id).join(',');
        body.sections_url = w.location.pathname;
      }
      try {
        const res = await fetch(((w.routes && w.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok || data.status) { err.textContent = data.description || data.message || i18n.i18nError || 'Something went wrong. Please try again.'; err.hidden = false; return; }
        if (typeof w.publish === 'function' && w.PUB_SUB_EVENTS) { try { w.publish(w.PUB_SUB_EVENTS.cartUpdate, { source: 'mb-product', productVariantId: item.id, cartData: data }); } catch (x) { /* noop */ } }
        if (drawer && data.sections) { drawer.classList.remove('is-empty'); drawer.renderContents({ id: item.id, sections: data.sections }); }
        else { w.location.href = (w.routes && w.routes.cart_url) || '/cart'; }
      } catch (x) {
        // Plain POST fallback: the form only gets its /cart/add action now (see the note in mb-product.liquid)
        if (form.dataset.action) form.setAttribute('action', form.dataset.action);
        form.submit();
      } finally {
        atc.classList.remove('is-loading');
      }
    });

    // Sticky bar appears once the real button scrolls off the top
    if (sticky && hasIO) {
      const btn = $('[data-mb-sticky-btn]', sticky);
      const io = new IntersectionObserver((es) => es.forEach((en) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (btn) btn.tabIndex = show ? 0 : -1;
        d.documentElement.classList.toggle('mb-has-sticky', show);
      }));
      io.observe(atc);
      if (btn) btn.addEventListener('click', () => { if (form.requestSubmit) form.requestSubmit(); else atc.click(); });
    }
  }

  /* ---------- Smooth scroll for in-page CTAs ---------- */
  function initAnchors() {
    d.addEventListener('click', (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute('href').slice(1);
      if (!id) return;
      const el = d.getElementById(id);
      if (!el) return;
      e.preventDefault();
      const top = el.getBoundingClientRect().top + w.scrollY - (parseInt(getComputedStyle(d.documentElement).getPropertyValue('--mb-header-h'), 10) || 72) - 12;
      w.scrollTo({ top, behavior: reduce ? 'auto' : 'smooth' });
      history.replaceState(null, '', '#' + id);
    });
  }

  /* ---------- Count-up numbers ---------- */
  function initCounters(root = d) {
    const els = $$('[data-mb-counter]', root).filter((el) => once(el, 'mbInit'));
    if (!els.length || !hasIO || reduce) return;
    const run = (el) => {
      const raw = String(el.dataset.mbCounter);
      const num = parseFloat(raw.replace(/,/g, ''));
      const dec = (raw.split('.')[1] || '').length;
      const start = performance.now();
      const step = (now) => {
        const k = Math.min(1, (now - start) / 1500);
        const e = 1 - Math.pow(1 - k, 3);
        el.textContent = (num * e).toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec });
        if (k < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { io.unobserve(e.target); run(e.target); } }), { threshold: 0.6 });
    els.forEach((el) => { if (el.getBoundingClientRect().top > w.innerHeight * 0.9) { el.textContent = '0'; io.observe(el); } });
  }

  /* ---------- Boot ---------- */
  function initAll(root = d) {
    initReveal(root);
    initTicker(root);
    initRails(root);
    initTabs(root);
    initCounters(root);
    $$('[data-mb-gallery]', root).forEach(initGallery);
    $$('[data-mb-pdp]', root).forEach(initPdp);
  }
  function boot() { initHeader(); initAnnounce(); initAnchors(); initAll(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', (e) => { if (e.target.querySelector('[data-mb-header]')) initHeader(); initAll(e.target); });
  // Sections that fill a rail after load (Judge.me carousel) re-run the dots on their own root
  w.mbInitRails = initRails;
})();
